/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionLeadFacility } from './PalAuthSubmissionLeadFacility';
import {
    PalAuthSubmissionLeadFacilityFromJSON,
    PalAuthSubmissionLeadFacilityFromJSONTyped,
    PalAuthSubmissionLeadFacilityToJSON,
    PalAuthSubmissionLeadFacilityToJSONTyped,
} from './PalAuthSubmissionLeadFacility';
import type { PalAuthSubmissionLeadStatus } from './PalAuthSubmissionLeadStatus';
import {
    PalAuthSubmissionLeadStatusFromJSON,
    PalAuthSubmissionLeadStatusFromJSONTyped,
    PalAuthSubmissionLeadStatusToJSON,
    PalAuthSubmissionLeadStatusToJSONTyped,
} from './PalAuthSubmissionLeadStatus';
import type { PalAuthSubmissionLeadWaitlist } from './PalAuthSubmissionLeadWaitlist';
import {
    PalAuthSubmissionLeadWaitlistFromJSON,
    PalAuthSubmissionLeadWaitlistFromJSONTyped,
    PalAuthSubmissionLeadWaitlistToJSON,
    PalAuthSubmissionLeadWaitlistToJSONTyped,
} from './PalAuthSubmissionLeadWaitlist';
import type { PalAuthSubmissionLeadAdmissionStatusInfo } from './PalAuthSubmissionLeadAdmissionStatusInfo';
import {
    PalAuthSubmissionLeadAdmissionStatusInfoFromJSON,
    PalAuthSubmissionLeadAdmissionStatusInfoFromJSONTyped,
    PalAuthSubmissionLeadAdmissionStatusInfoToJSON,
    PalAuthSubmissionLeadAdmissionStatusInfoToJSONTyped,
} from './PalAuthSubmissionLeadAdmissionStatusInfo';
import type { PalAuthSubmissionLeadExternalEhrPatient } from './PalAuthSubmissionLeadExternalEhrPatient';
import {
    PalAuthSubmissionLeadExternalEhrPatientFromJSON,
    PalAuthSubmissionLeadExternalEhrPatientFromJSONTyped,
    PalAuthSubmissionLeadExternalEhrPatientToJSON,
    PalAuthSubmissionLeadExternalEhrPatientToJSONTyped,
} from './PalAuthSubmissionLeadExternalEhrPatient';
import type { PalAuthSubmissionLeadScreenerLeadInfo } from './PalAuthSubmissionLeadScreenerLeadInfo';
import {
    PalAuthSubmissionLeadScreenerLeadInfoFromJSON,
    PalAuthSubmissionLeadScreenerLeadInfoFromJSONTyped,
    PalAuthSubmissionLeadScreenerLeadInfoToJSON,
    PalAuthSubmissionLeadScreenerLeadInfoToJSONTyped,
} from './PalAuthSubmissionLeadScreenerLeadInfo';

/**
 * 
 * @export
 * @interface PalAuthSubmissionLead
 */
export interface PalAuthSubmissionLead {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    original_facility_id?: string | null;
    /**
     * 
     */
    lead_received_date?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    source_name?: string;
    /**
     * 
     */
    status_id?: string;
    /**
     * 
     */
    failed_review_stage_status_id?: string | null;
    /**
     * 
     */
    bd_action_failed?: boolean | null;
    /**
     * 
     */
    auto_accepted_by_ai?: boolean;
    /**
     * 
     */
    internal_response_reason?: string;
    /**
     * 
     */
    external_response_reason?: string;
    /**
     * 
     */
    connector?: PalAuthSubmissionLeadConnectorEnum;
    /**
     * 
     */
    status?: PalAuthSubmissionLeadStatus;
    /**
     * 
     */
    waitlist?: PalAuthSubmissionLeadWaitlist;
    /**
     * Legacy display name. Use `admission_status_code`.
     * @deprecated
     */
    admission_status?: PalAuthSubmissionLeadAdmissionStatusEnum;
    /**
     * Canonical admission-status code; legality enforced by backend state machines.
     */
    admission_status_code?: PalAuthSubmissionLeadAdmissionStatusCodeEnum;
    /**
     * 
     */
    screener_lead_info?: PalAuthSubmissionLeadScreenerLeadInfo;
    /**
     * 
     */
    facility?: PalAuthSubmissionLeadFacility;
    /**
     * 
     */
    external_ehr_patient?: PalAuthSubmissionLeadExternalEhrPatient;
    /**
     * 
     */
    admission_status_info?: PalAuthSubmissionLeadAdmissionStatusInfo;
}


/**
 * @export
 */
export const PalAuthSubmissionLeadConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAscension: 'EpicCare Link Ascension',
    EpicCareLinkAscensionWi: 'EpicCare Link Ascension WI',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkAtriumHealth: 'EpicCare Link Atrium Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBaptistOneCare: 'EpicCare Link Baptist One Care',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCarolinaEast: 'EpicCare Link Carolina East',
    EpicCareLinkErlanger: 'EpicCare Link Erlanger',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkConeHealth: 'EpicCare Link Cone Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFirstHealth: 'EpicCare Link FirstHealth',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkSelectMedical: 'EpicCare Link Select Medical',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkGuthrie: 'EpicCare Link Guthrie',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHackensackMeridianHealth: 'EpicCare Link Hackensack Meridian Health',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkJupiterMedicalCenter: 'EpicCare Link Jupiter Medical Center',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMethodistHealthSystem: 'EpicCare Link Methodist Health System',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNch: 'EpicCare Link NCH',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOchsnerHealthNetwork: 'EpicCare Link Ochsner Health Network',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkProvidenceWashington: 'EpicCare Link Providence Washington',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkSalemHealth: 'EpicCare Link Salem Health',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkStormontVailHealth: 'EpicCare Link Stormont Vail Health',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfKansasStFrancis: 'EpicCare Link University of Kansas St Francis',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityOfMississippiMedicalCenter: 'EpicCare Link University of Mississippi Medical Center',
    EpicCareLinkUniversityOfRochesterMedicine: 'EpicCare Link University of Rochester Medicine',
    EpicCareLinkUniversityHealth: 'EpicCare Link University Health',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkSouthcoast: 'EpicCare Link Southcoast',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    EpicCareLinkGeisinger: 'EpicCare Link Geisinger',
    EpicCareLinkJpsHealthNetwork: 'EpicCare Link JPS Health Network',
    EpicCareLinkPortneuf: 'EpicCare Link Portneuf',
    EpicCareLinkCheyenneRegionalMedicalCenter: 'EpicCare Link Cheyenne Regional Medical Center',
    EpicCareLinkUniversityMedicalCenter: 'EpicCare Link University Medical Center',
    EpicCareLinkCapeFearValley: 'EpicCare Link Cape Fear Valley',
    EpicCareLinkLexingtonMedicalCenter: 'EpicCare Link Lexington Medical Center',
    EpicCareLinkMedicalUniversityOfSouthCarolina: 'EpicCare Link Medical University of South Carolina',
    EpicCareLinkEssentiaHealth: 'EpicCare Link Essentia Health',
    EpicCareLinkUwHealth: 'EpicCare Link UW Health',
    EpicCareLinkNorthMississippiHealthServices: 'EpicCare Link North Mississippi Health Services',
    EpicCareLinkOregonHealthScienceUniversity: 'EpicCare Link Oregon Health & Science University',
    EpicCareLinkLcmcHealth: 'EpicCare Link LCMC Health',
    EpicCareLinkRwjBarnabas: 'EpicCare Link RWJ Barnabas',
    EpicCareLinkLovelaceHealthSystem: 'EpicCare Link Lovelace Health System',
    EpicCareLinkRochesterRegionalHealth: 'EpicCare Link Rochester Regional Health',
    EpicCareLinkAtlanticHealth: 'EpicCare Link Atlantic Health',
    EpicCareLinkBalladHealth: 'EpicCare Link Ballad Health',
    EpicCareLinkGreatRiver: 'EpicCare Link Great River',
    EpicCareLinkMountainsideMedicalCenter: 'EpicCare Link Mountainside Medical Center',
    EpicCareLinkUkHealthCare: 'EpicCare Link UK HealthCare',
    EpicCareLinkCghMedicalCenter: 'EpicCare Link CGH Medical Center',
    EpicCareLinkMosaicLifeCare: 'EpicCare Link Mosaic Life Care',
    EpicCareLinkGundersenHealth: 'EpicCare Link Gundersen Health',
    EpicCareLinkCoxHealth: 'EpicCare Link CoxHealth',
    EpicCareLinkSingingRiver: 'EpicCare Link Singing River',
    EpicCareLinkLickingMemorialHealth: 'EpicCare Link Licking Memorial Health',
    EpicCareLinkWakeMed: 'EpicCare Link WakeMed',
    EpicCareLinkAdventist: 'EpicCare Link Adventist',
    EpicCareLinkEvergreenHealth: 'EpicCare Link Evergreen Health',
    EpicCrnVendorServicesSandbox: 'Epic CRN Vendor Services Sandbox',
    EpicCrnUmms: 'Epic CRN UMMS',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    Repisodic: 'Repisodic',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next',
    Roc: 'Roc',
} as const;
export type PalAuthSubmissionLeadConnectorEnum = typeof PalAuthSubmissionLeadConnectorEnum[keyof typeof PalAuthSubmissionLeadConnectorEnum];

/**
 * @export
 */
export const PalAuthSubmissionLeadAdmissionStatusEnum = {
    Booked: 'Booked',
    MovedIn: 'Moved-In',
    MovedOut: 'Moved-Out',
    Lost: 'Lost',
    Hospitalized: 'Hospitalized',
    Loa: 'LOA',
    IntakeInProgress: 'Intake in Progress',
    Selected: 'Selected',
    Scheduled: 'Scheduled',
    Admitted: 'Admitted',
    Transferred: 'Transferred',
    Discharged: 'Discharged',
    NoAdmit: 'No Admit',
    ReadyForAdmission: 'Ready for Admission',
    Deceased: 'Deceased',
} as const;
export type PalAuthSubmissionLeadAdmissionStatusEnum = typeof PalAuthSubmissionLeadAdmissionStatusEnum[keyof typeof PalAuthSubmissionLeadAdmissionStatusEnum];

/**
 * @export
 */
export const PalAuthSubmissionLeadAdmissionStatusCodeEnum = {
    Booked: 'booked',
    MovedIn: 'moved_in',
    MovedOut: 'moved_out',
    Lost: 'lost',
    Hospitalized: 'hospitalized',
    Loa: 'loa',
    None: 'none',
    IntakeInProgress: 'intake_in_progress',
    Selected: 'selected',
    Scheduled: 'scheduled',
    Admitted: 'admitted',
    Transferred: 'transferred',
    Discharged: 'discharged',
    NoAdmit: 'no_admit',
    ReadyForAdmission: 'ready_for_admission',
    Deceased: 'deceased',
} as const;
export type PalAuthSubmissionLeadAdmissionStatusCodeEnum = typeof PalAuthSubmissionLeadAdmissionStatusCodeEnum[keyof typeof PalAuthSubmissionLeadAdmissionStatusCodeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionLead interface.
 */
export function instanceOfPalAuthSubmissionLead(value: object): value is PalAuthSubmissionLead {
    return true;
}

export function PalAuthSubmissionLeadFromJSON(json: any): PalAuthSubmissionLead {
    return PalAuthSubmissionLeadFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'original_facility_id': json['original_facility_id'] === undefined ? undefined : json['original_facility_id'] === null ? null : json['original_facility_id'],
        'lead_received_date': json['lead_received_date'] == null ? undefined : json['lead_received_date'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'source_name': json['source_name'] == null ? undefined : json['source_name'],
        'status_id': json['status_id'] == null ? undefined : json['status_id'],
        'failed_review_stage_status_id': json['failed_review_stage_status_id'] === undefined ? undefined : json['failed_review_stage_status_id'] === null ? null : json['failed_review_stage_status_id'],
        'bd_action_failed': json['bd_action_failed'] === undefined ? undefined : json['bd_action_failed'] === null ? null : json['bd_action_failed'],
        'auto_accepted_by_ai': json['auto_accepted_by_ai'] == null ? undefined : json['auto_accepted_by_ai'],
        'internal_response_reason': json['internal_response_reason'] == null ? undefined : json['internal_response_reason'],
        'external_response_reason': json['external_response_reason'] == null ? undefined : json['external_response_reason'],
        'connector': json['connector'] == null ? undefined : json['connector'],
        'status': json['status'] == null ? undefined : PalAuthSubmissionLeadStatusFromJSON(json['status']),
        'waitlist': json['waitlist'] == null ? undefined : PalAuthSubmissionLeadWaitlistFromJSON(json['waitlist']),
        'admission_status': json['admission_status'] == null ? undefined : json['admission_status'],
        'admission_status_code': json['admission_status_code'] == null ? undefined : json['admission_status_code'],
        'screener_lead_info': json['screener_lead_info'] == null ? undefined : PalAuthSubmissionLeadScreenerLeadInfoFromJSON(json['screener_lead_info']),
        'facility': json['facility'] == null ? undefined : PalAuthSubmissionLeadFacilityFromJSON(json['facility']),
        'external_ehr_patient': json['external_ehr_patient'] == null ? undefined : PalAuthSubmissionLeadExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'admission_status_info': json['admission_status_info'] == null ? undefined : PalAuthSubmissionLeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
    };
}

export function PalAuthSubmissionLeadToJSON(json: any): PalAuthSubmissionLead {
    return PalAuthSubmissionLeadToJSONTyped(json, false);
}

export function PalAuthSubmissionLeadToJSONTyped(value?: PalAuthSubmissionLead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'original_facility_id': value['original_facility_id'],
        'lead_received_date': value['lead_received_date'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'source_name': value['source_name'],
        'status_id': value['status_id'],
        'failed_review_stage_status_id': value['failed_review_stage_status_id'],
        'bd_action_failed': value['bd_action_failed'],
        'auto_accepted_by_ai': value['auto_accepted_by_ai'],
        'internal_response_reason': value['internal_response_reason'],
        'external_response_reason': value['external_response_reason'],
        'connector': value['connector'],
        'status': PalAuthSubmissionLeadStatusToJSON(value['status']),
        'waitlist': PalAuthSubmissionLeadWaitlistToJSON(value['waitlist']),
        'admission_status': value['admission_status'],
        'admission_status_code': value['admission_status_code'],
        'screener_lead_info': PalAuthSubmissionLeadScreenerLeadInfoToJSON(value['screener_lead_info']),
        'facility': PalAuthSubmissionLeadFacilityToJSON(value['facility']),
        'external_ehr_patient': PalAuthSubmissionLeadExternalEhrPatientToJSON(value['external_ehr_patient']),
        'admission_status_info': PalAuthSubmissionLeadAdmissionStatusInfoToJSON(value['admission_status_info']),
    };
}

